import React, { useCallback, useState } from 'react';
import { useField } from 'react-final-form';
import { TextField } from 'ksnm-common-ui/lib/Form/InputFields';

import { confirmDialogStore } from '@stores/confirmDialog';
import { EMPTY_PASSWORD_TYPE_VALUE } from '@stores/settingsStore/constants';

export const PasswordField = ({
  name,
  label,
  emptyNameField,
  required,
}: {
  name: string;
  label?: string;
  required?: boolean;
  emptyNameField: string;
}): React.ReactElement => {
  const {
    input: { value, onChange },
  } = useField(name);

  const {
    input: { onChange: onChangeEmptyNameField },
  } = useField(emptyNameField);

  const [key, setKey] = useState(-1);

  const handleFocus = useCallback(() => {
    if (value === EMPTY_PASSWORD_TYPE_VALUE) {
      confirmDialogStore.open({
        text: 'Вы уверены, что хотите изменить пароль?',
        onOk: () => {
          onChange('');
          onChangeEmptyNameField(true);
        },
        onCancel: () => {
          // Необходимо для сброса фокуса
          setKey(Date.now());
        },
        onClose: () => {
          setKey(Date.now());
        },
      });
    }
  }, [onChange, onChangeEmptyNameField, value]);

  const handleChange = useCallback(
    (v) => {
      if (v) onChangeEmptyNameField(false);
      else onChangeEmptyNameField(true);
    },
    [onChangeEmptyNameField],
  );

  return (
    <div key={key} onClick={handleFocus}>
      <TextField
        name={name}
        label={label}
        type={value === EMPTY_PASSWORD_TYPE_VALUE ? 'password' : 'text'}
        size="small"
        onChange={handleChange}
        maxLength={200}
        required={required}
        placeholder={value === '' ? 'Введите новое значение или будет использовано значение по умолчанию' : ''}
      />
    </div>
  );
};
